import React, { useEffect, useState } from "react";
import "./HomeContent.css";
import FeaturedProgramsData from "../../data/FeaturedProgramsData.json";
import RecentUpdatesSection from "./RecentUpdatesSection";
import UpcomingEventsSection from "./UpcomingEventsSection";
// import TestimonialSection from "./TestimonialSection";
import TestimonialSectionNew from "./TestimonialSectionNew";
import AOS from "aos";
import "aos/dist/aos.css";
import HomeNavbarmenu from "./HomeNavbarmenu";
import HomeSideNavbar from "./HomeSideNavbar";
import Floaticons from "./Floaticons";
import HomeRightFloatIcons from "./HomeRightFloatIcons";
import FeaturedProgramSection from "./FeaturedProgramSection";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { SearchBar } from "../../Pages/Search";
import { onChange } from "../Redux/SearchSlice";


function HomeContent() {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;

  useEffect(() => {
    AOS.init({ duration: 800 });
     onMouseClick()
  }, []);

  const totalPages = Math.ceil(FeaturedProgramsData.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = FeaturedProgramsData.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const dispatch = useDispatch()
     const onMouseClick = () =>{
             dispatch(onChange())
  }
 const selector = useSelector(state=>state.search.value)
  return (
    <>
      <div className="navbar-holder">
        <HomeNavbarmenu />
      </div>
      <div className="home-sidenavbar-holder">
        <HomeSideNavbar />
      </div>
       {selector && selector!==""? <SearchBar/>: <>
      <div className="HomeRightFloatIcons-holder">
        <HomeRightFloatIcons />
      </div>
      <Floaticons />
      <div id="main" className="video-container">
        <title>L-TT Home</title>
        {/* <h1 className="sr-only" tabIndex={0}>
          Transform Today & Lead Tomorrow
        </h1> */}
        <img
          src={
            process.env.PUBLIC_URL +
            "/images/Banners/home-banner-mobile-latest.png"
          }
          alt="home-banner"
          className="banner-img mobile-banner"
        />
        <img
          src={
            process.env.PUBLIC_URL +
            "/images/Banners/home-banner-brand-without-text.png"
          }
          alt="home-banner"
          className="banner-img desktop-banner"
        />
        <div className="home-text-box">
          <h1 tabIndex={0}>
            Get ready to learn, <br /> lead, and reinvent - together
          </h1>
          <div className="banner-subtext-row">
            <div className="banner-subtext-box">
              <div className="banner-subtext-img-box">
                <img
                  src={process.env.PUBLIC_URL + "/images/Home/banner-icon1.png"}
                  alt="icon"
                  className="banner-icon"
                />
              </div>
              <p>
                Evolve as a <br /> 360<sup>o</sup> Technologist
              </p>
            </div>
            <div className="banner-subtext-box">
              <div className="banner-subtext-img-box">
                <img
                  src={process.env.PUBLIC_URL + "/images/Home/banner-icon2.png"}
                  alt="icon"
                  className="banner-icon"
                />
              </div>
              <p>
                Be Future <br /> Ready
              </p>
            </div>
          </div>
          <div className="banner-subtext-row">
            <div className="banner-subtext-box">
              <div className="banner-subtext-img-box">
                <img
                  src={process.env.PUBLIC_URL + "/images/Home/banner-icon4.png"}
                  alt="icon"
                  className="banner-icon"
                />
              </div>
              <p>
                Experience Transformed <br /> Learning Methods
              </p>
            </div>
            <div className="banner-subtext-box">
              <div className="banner-subtext-img-box">
                <img
                  src={process.env.PUBLIC_URL + "/images/Home/banner-icon3.png"}
                  alt="icon"
                  className="banner-icon"
                />
              </div>
              <p>
                Explore Role-Aligned <br /> Curriculum
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* first section */}
      <div className="featured-programs-container">
        <FeaturedProgramSection />
      </div>
      {/* third section */}
      <div className="upcoming-events-container">
        <div className="upcoming-events-wrap">
          <UpcomingEventsSection />
        </div>
      </div>
      {/* second section */}
      <div className="recent-updates-container">
        <div className="recent-updates-wrap">
          <RecentUpdatesSection />
        </div>
      </div>

      {/* fourth section */}
      <div className="testimonial-container">
        <div className="testimonial-wrap">
          <div className="heading-box">
            <h2 className="main-headings">Testimonials</h2>
          </div>
          <TestimonialSectionNew />
        </div>
      </div>
      </>}
    </>
  );
}

export default HomeContent;
